export const scrollToSection = (
  sectionId: string,
  containerId: string,
): void => {
  requestAnimationFrame(() => {
    const target = document.getElementById(sectionId);
    const scrollContainer = document.getElementById(containerId);

    if (!target || !scrollContainer) {
      return;
    }

    const offset =
      target.getBoundingClientRect().top -
      scrollContainer.getBoundingClientRect().top +
      scrollContainer.scrollTop;

    scrollContainer.scrollTo({ top: offset, behavior: "smooth" });
  });
};
